const clampRosterSize = (value, capacity) => (
  Math.min(Math.max(Number(value) || 1, 1), Math.max(Number(capacity) || 1, 1))
);

export const createPartnerBookingDraft = slot => {
  const isInvitationSlot = Boolean(
    slot
    && Number(slot.presetPlaces) > 1
    && slot.minimumPlayers !== null
    && slot.minimumPlayers !== undefined
  );
  const playersNumber = isInvitationSlot
    ? clampRosterSize(slot.minimumPlayers, slot.presetPlaces)
    : 1;

  return {
    bookingNotes: '',
    description: null,
    otherPlayers: new Array(playersNumber).fill(''),
    otherPlayersDiscountReason: new Array(playersNumber).fill(''),
    otherPlayersMember: new Array(playersNumber).fill(false),
    otherPlayersPayment: new Array(playersNumber).fill(false),
    otherPlayersPrice: new Array(playersNumber).fill(0),
    payment: false,
    playersNumber
  };
};
